import React from 'react';

const Hero = () => {
  return (
    <section className="relative w-full bg-charcoal overflow-hidden pt-0">
      {/* Mobile Hero: Full Artwork Visible */}
      <div className="block md:hidden w-full bg-charcoal">
        <img 
          src="https://ik.imagekit.io/aeu02xvjgn/Oct17.jpg" 
          alt="Padua Weddings October 17 Available" 
          className="w-full h-auto max-h-[72vh] object-contain"
        />
      </div>

      {/* Desktop Hero: Immersive Editorial */}
      <div className="hidden md:block relative h-[80vh] max-h-[900px] w-full">
        <img 
          src="https://ik.imagekit.io/aeu02xvjgn/Oct17.jpg" 
          alt="Padua Weddings Editorial" 
          className="w-full h-full object-cover object-center transition-transform duration-[3s] hover:scale-105"
        />
        {/* Soft cinematic overlay for desktop transition */}
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-transparent to-transparent opacity-80"></div>
      </div>
      
      {/* Subtle bottom glow to bridge sections */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-charcoal to-transparent"></div>
    </section>
  );
};

export default Hero;